/**
 * @desc 子库转移入库推送EBS
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/test/transferPushEbs`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
